module.exports = __webpack_public_path__ + "img/agent-center.7e08b916.png";